<template>
  <div class="portfolio-container" id="portfolio">
    <div class="portfolio-latest">{{ $t('portfolio.main-header') }}</div>
    <div class="portfolio-projects">{{ $t('portfolio.sub-header') }}</div>
    <PortfolioElement
      v-for="item in portfolio"
      :key="item.id"
      :portfolio="item.item"
      :width="width"
    />
  </div>
</template>

<script>
import PortfolioElement from "./PortfolioElement";
import portfolio from "../configs/portfolio";

export default {
  name: "portfolio-container",
  props: {
    width: { type: Number, default: null }
  },
  components: {
    PortfolioElement
  },
  data: () => {
    return {
      portfolio
    };
  }
};
</script>

<style scoped lang="scss">
.portfolio-container {
  // background-color: #FFFAF0;
  min-height: 500px;
}

.portfolio-latest {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  color: #000000;
  margin-bottom: 5px;
  margin-top: 150px;

  @media screen and (max-width: 1130px) {
    margin-top: 130px;
  }

  @media screen and (max-width: 1012px) {
    margin-top: 130px;
  }

  @media screen and (max-width: 767px) {
    font-size: 18px;
    margin-top: 70px;
  }

  @media screen and (max-width: 479px) {
    font-size: 16px;
    margin-bottom: 1px;
  }
}

.portfolio-projects {
  font-family: Roboto;

  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  color: #000000;
  margin-bottom: 110px;

  @media screen and (max-width: 1130px) {
    margin-bottom: 90px;
  }

  @media screen and (max-width: 767px) {
    font-size: 48px;
    margin-bottom: 40px;
  }

  @media screen and (max-width: 479px) {
    font-size: 44px;
    margin-bottom: 70px;
  }
}

.mirror-render {
  transform: scale(-1, 1);
  text-align: right;
}
</style>
